import React, { useEffect, useState, useRef } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { IconFiles, IconEye } from "@tabler/icons-react";
import { API_ENDPOINTS } from "../../../constant/_constant";
import usePostRequest from "../../../hooks/usePostRequest";

function PackslipAttachments({ show, onHide, attachmnetid, onConfirm }) {
  // { [file.id]: { file_name, original_name, url } }
  const [selectedMap, setSelectedMap] = useState({});
  const pendingIdRef = useRef(null);
  const [previewLoadingId, setPreviewLoadingId] = useState(null);

  const {
    isLoading: fetchLoading,
    data: attachmentData,
    postData: fetchFiles,
  } = usePostRequest(API_ENDPOINTS.FETCH_ATTACHMENTS);

  const {
    isLoading: linkLoading,
    data: fetchLink,
    postData: GetAttachment,
  } = usePostRequest(API_ENDPOINTS.VIEW_ATTACHMENTS);

  useEffect(() => {
    if (show && attachmnetid) {
      setSelectedMap({});
      fetchFiles({ attachment_id: attachmnetid });
    }
  }, [show]);

  // When fetchLink resolves, store the URL against the pending file id
  useEffect(() => {
    if (fetchLink?.data && pendingIdRef.current) {
      const fileId = pendingIdRef.current;
      const file = files.find((f) => f.id === fileId);
      if (file) {
        setSelectedMap((prev) => ({
          ...prev,
          [fileId]: {
            original_name: file.original_name,
            original_name: file.original_name,
            url: fetchLink.data,
          },
        }));
      }
      pendingIdRef.current = null;
    }
  }, [fetchLink]);

  useEffect(() => {
    if (previewLoadingId?.endsWith("_done") && fetchLink?.data) {
      window.open(fetchLink.data, "_blank");
      setPreviewLoadingId(null);
    }
  }, [fetchLink, previewLoadingId]);

  const handleCheckboxChange = (file, checked) => {
    if (checked) {
      pendingIdRef.current = file.id;
      GetAttachment({ id: file.id });
    } else {
      setSelectedMap((prev) => {
        const updated = { ...prev };
        delete updated[file.id];
        return updated;
      });
    }
  };

  const handleConfirm = () => {
    const selected = Object.values(selectedMap);
    onConfirm({
      fileNames: selected.map((s) => s.original_name),
      fileUrls: selected.map((s) => s.url),
    });
    onHide();
  };

  const files = attachmentData?.data || [];
  const selectedCount = Object.keys(selectedMap).length;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <IconFiles stroke={1.25} /> Order Attachments
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {fetchLoading ? (
          <div className="text-center py-3">
            <Spinner animation="border" size="sm" />
          </div>
        ) : files.length === 0 ? (
          <p className="text-muted text-center">No attachments found.</p>
        ) : (
          <div className="d-flex flex-column gap-2">
            {files.map((file) => {
              const isChecked = !!selectedMap[file.id];
              const isPending = pendingIdRef.current === file.id && linkLoading;

              return (
                <div
                  key={file.id}
                  className="d-flex align-items-center gap-2 border rounded p-2"
                >
                  {isPending ? (
                    <Spinner animation="border" size="sm" className="me-1" />
                  ) : (
                    <Form.Check
                      type="checkbox"
                      id={`attachment-${file.id}`}
                      label=""
                      checked={isChecked}
                      onChange={(e) =>
                        handleCheckboxChange(file, e.target.checked)
                      }
                    />
                  )}
                  <span
                    className="text-truncate flex-grow-1"
                    title={file.original_name}
                  >
                    {file.original_name}
                  </span>
                  <span
                    style={{ cursor: "pointer" }}
                    className="text-primary ms-auto"
                    title="View attachment"
                    // onClick={async () => {
                    //   const res = await GetAttachment({ id: file.id });
                    //   const url = res?.data || fetchLink?.data;
                    //   if (url) window.open(url, "_blank");
                    // }}
                    onClick={async () => {
                      setPreviewLoadingId(file.id);
                      await GetAttachment({ id: file.id });
                      setPreviewLoadingId(file.id + "_done");
                    }}
                  >
                    {previewLoadingId === file.id ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <IconEye size={18} stroke={1.5} />
                    )}
                    {/* <IconEye size={18} stroke={1.5} /> */}
                  </span>
                </div>
              );
            })}
            {/* {files.map((file) => {
              const isChecked = !!selectedMap[file.id];
              const isPending = pendingIdRef.current === file.id && linkLoading;

              return (
                <div
                  key={file.id}
                  className="d-flex align-items-center gap-2 border rounded p-2"
                >
                  {isPending ? (
                    <Spinner animation="border" size="sm" className="me-1" />
                  ) : (
                    <Form.Check
                      type="checkbox"
                      id={`attachment-${file.id}`}
                      label=""
                      checked={isChecked}
                      onChange={(e) =>
                        handleCheckboxChange(file, e.target.checked)
                      }
                    />
                  )}
                  <span className="text-truncate" title={file.original_name}>
                    {file.original_name}
                  </span>
                </div>
              );
            })} */}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <Button
          variant="warning"
          onClick={handleConfirm}
          disabled={selectedCount === 0}
        >
          Confirm ({selectedCount} selected)
        </Button>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PackslipAttachments;
